import { useCallback } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "../../state/store";
import {
  resetDeviceGroups,
  setDeviceGroupsLoading,
  setDeviceGroupsRefresh
} from "../../state/ducks";

import { strCode } from "../../consts";
import { deviceGroupsService, log, notificationService, t } from "../../services";
import { deviceGroupUtils } from "../../utils";

export const useFetchDeviceGroups = () => {
  const deviceGroups = useSelector((store) => store.deviceGroups?.groups);
  const loading = useSelector((store) => store.deviceGroups?.loading);
  const refresh = useSelector((store) => store.deviceGroups?.refresh);

  const fetchCallback = useCallback(
    async (isRefresh) => {
      if ((deviceGroups !== null && !isRefresh) || loading) {
        return;
      }

      dispatch(setDeviceGroupsLoading(true));

      try {
        dispatch(resetDeviceGroups());

        await deviceGroupsService.fetchGroups();
      } catch (error) {
        log.error("fetchDeviceGroups error", error);

        notificationService.showError({
          title: t(strCode.FETCH_DEVICE_GROUPS_ERROR),
          message: t(
            deviceGroupUtils.parseGroupsErrorMessage(
              error?.response?.data?.error ? error.response.data.error : error?.toString()
            )
          )
        });
      } finally {
        dispatch(setDeviceGroupsLoading(false));
        dispatch(setDeviceGroupsRefresh(false));
      }
    },
    [refresh, deviceGroups, loading]
  );

  return { fetchCallback, data: deviceGroups, loading, refresh };
};
